import { Stack, Text } from '@fluentui/react';

import FormsSide from './FormsSide';
import ViewSide from './ViewSide';

export default () => {
  return (
    <div style={{ marginTop: "6px" }}>
      <Stack horizontal horizontalAlign="center" tokens={{ childrenGap: 20 }}>
        <Stack tokens={{ childrenGap: 10 }}>
          <Text variant="xxLarge">Teslim Kağıdı</Text>
          <FormsSide />
        </Stack>
        <Stack.Item style={{ width: "50%" }}>
          <ViewSide />
        </Stack.Item>
      </Stack>
    </div>
  );
};
